<template>
    <div class="customer-sap">
        <v-card>
            <v-card-title class="pt-2 pb-2">
                <TippTitle
                    position="bottom"
                    :tipp="about"
                    title="SAP"
                    :loading="purchasesSapNoz.loading || purchasesSapMhn.loading"
                    :reloadCb="reloadCb"
                />
            </v-card-title>
            <v-card-text class="pt-0">
                <KeineDaten v-if="sapPurchaseKeys.length <= 0"></KeineDaten>
                <v-tabs
                        v-model="activeTab"
                        v-if="sapPurchaseKeys.length > 0"
                >
                    <v-tab
                            v-for="(purchase, index) in sapPurchaseKeys"
                            :key="`customer-sap__tab-${sapPurchaseKeys[index]}`"
                    >
                        {{ purchase }}
                    </v-tab>
                    <v-tab-item
                            v-for="(purchase, index) in sapPurchasesAsArray"
                            :key="`customer-sap__tab-item-${sapPurchaseKeys[index]}`"
                    >
                        <SapProGp :purchase="purchase" />
                    </v-tab-item>
                </v-tabs>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import SapProGp from '@/components/customer/SapProGp.vue';
import KeineDaten from '@/components/customer/KeineDaten.vue';
import TippTitle from '@/components/TippTitle.vue';

export default {
    name: 'Sap',
    components: {
        SapProGp,
        KeineDaten,
        TippTitle,
    },
    data() {
        return {
            activeTab: null,
            about: 'Zeigt die Druckerzeugnisse und Produkte des Kunden mit Gültigkeitszeitraum und Leistungsumfang an. Werden keine Daten angezeigt, ist der Benutzer lediglich registriert und noch kein Kunde oder der Benutzer ist noch nicht mit einer GP-Nummer verknüpft.',
        };
    },
    computed: {
        ...mapGetters('customerDetail', ['sapPurchasesAsArray', 'sapPurchaseKeys']),
        ...mapState('customerDetail', ['purchasesSapNoz', 'purchasesSapMhn']),
    },
    methods: {
        ...mapActions('customerDetail', ['getPurchasesSapMhn', 'getPurchasesSapNoz']),
        reloadCb() {
            this.getPurchasesSapMhn();
            this.getPurchasesSapNoz();
        },
    },
};
</script>

<style scoped lang="scss"></style>
